.interactive-preview-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    background: linear-gradient(180deg, var(--plum-bg) 0%, var(--plum-bg-dk) 100%);
    padding: 16px 24px 0 24px;
    box-sizing: border-box;
    gap: 16px;
}
